import { useEffect, useState } from 'react';

export function PageLoader() {
  // Start hidden — the boot shell in index.html covers the screen for the first ~1.2s.
  // We fade in the spinner only after that window passes to avoid a double-flash.
  const [visible, setVisible] = useState(false);
  const [isTakingLong, setIsTakingLong] = useState(false);

  useEffect(() => {
    // Show spinner only after boot shell has faded out (~1.2s)
    const showId = window.setTimeout(() => setVisible(true), 1200);
    const longId  = window.setTimeout(() => setIsTakingLong(true), 5000);
    return () => {
      window.clearTimeout(showId);
      window.clearTimeout(longId);
    };
  }, []);

  if (!visible) {
    // Transparent placeholder — keeps the DOM stable while boot shell is visible
    return <div className="min-h-screen" aria-hidden="true" />;
  }

  return (
    <div className="min-h-screen grid place-items-center px-4 text-center animate-in fade-in duration-300">
      <div className="space-y-3">
        <div className="mx-auto h-8 w-8 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
        <p className="text-sm text-muted-foreground">Loading...</p>
        {isTakingLong ? (
          <button
            type="button"
            className="text-sm font-semibold text-primary hover:underline"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        ) : null}
      </div>
    </div>
  );
}
